import * as types from './types'

interface IViewPayload {
  id: number
  data?: any
}

export interface IViewAction {
  type: string
  payload?: IViewPayload
}

const selectClass = (id: number) => ({
  type: types.USER_SELECT_CLASS,
  payload: {
    id
  }
})
const deselectClass = (id: number) => ({
  type: types.USER_DESELECT_CLASS,
  payload: {
    id
  }
})
const deleteView = (id: number) => ({
  type: types.USER_DELETE_VIEW,
  payload: {
    id
  }
})

const addFactoid = (id: number, businessLineId: number) => ({
  type: types.USER_SELECT_FACTOID,
  payload: {
    id,
    businessLineId
  }
})

const removeFactoid = (id: number, businessLineId: number) => ({
  type: types.USER_DESELECT_FACTOID,
  payload: {
    id,
    businessLineId
  }
})

const removeBusinessLine = (id: number) => ({
  type: types.USER_REMOVE_BUSINESS_LINE,
  payload: {
    id
  }
})

const addBusinessLine = (id: number) => ({
  type: types.USER_ADD_BUSINESS_LINE,
  payload: {
    id
  }
})

const addBusinessLineRecommendation = (id: number) => ({
  type: types.USER_ADD_BUSINESS_LINE_RECOMMENDATION,
  payload: {
    id
  }
})

const resetJourney = () => ({
  type: types.RESET_SELECTIONS
})

export {
  selectClass,
  deselectClass,
  deleteView,
  addFactoid,
  removeFactoid,
  removeBusinessLine,
  addBusinessLine,
  addBusinessLineRecommendation,
  resetJourney
}



// WEBPACK FOOTER //
// ./src/views/duck/actions.ts